module.exports = __webpack_public_path__ + "img/ggl1.74d3ab61.svg";